import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';

const LanguageModal = () => {
  const { needsSelection, setLang, t } = useLanguage();
  if (!needsSelection) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4"
      data-testid="language-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="language-modal-title"
    >
      <div className="bg-white dark:bg-black border-2 border-border w-full max-w-md p-8 text-center shadow-xl">
        <div className="mb-6 flex justify-center">
          <Logo size="default" />
        </div>
        <h2 id="language-modal-title" className="text-3xl font-serif-kannada font-bold mb-2">
          {t('chooseLanguage')}
        </h2>
        <p className="text-sm text-muted-foreground mb-8">Choose Your Language · ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button
            type="button"
            onClick={() => setLang('kn')}
            className="px-6 py-4 border-2 border-border font-serif-kannada text-xl hover:bg-primary hover:text-white hover:border-primary transition-colors"
            data-testid="lang-select-kn"
          >
            ಕನ್ನಡ
          </button>
          <button
            type="button"
            onClick={() => setLang('en')}
            className="px-6 py-4 border-2 border-border font-label text-lg hover:bg-primary hover:text-white hover:border-primary transition-colors"
            data-testid="lang-select-en"
          >
            English
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
